import React, { useContext, useState } from 'react'
import './RequestAction.css'
import { POST_ENDPOINT } from '../api/API'
import { AdminContext } from '../contexts/AdminContext';
import { UserApplicationRequests } from '../interfaces/APIInterface';
import Button from '@mui/material/Button';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import TextField from '@mui/material/TextField';

interface RequestActionProps {
    actionPopup: "app" | "group" | "",
    setActionPopup: React.Dispatch<React.SetStateAction<"app" | "group" | "">>,
    currentUser: UserApplicationRequests,
    appName: string,
    appId: string,
    submitRequestAction: (action: POST_ENDPOINT, body: {requestId: string, applicationId: string, adminId: string, reason: string})=> Promise<void>,
    userRedirect: (navigateTo: {pathname: string, search: string}) => void
}

const RequestActionApplication = (props: RequestActionProps) => {
    const [reason, setReason] = useState('');
    const [showDenyError, setShowDenyError] = useState(false);

    const {adminCredentials, getToken} = useContext(AdminContext);
    const closePopup = () => {
        props.setActionPopup("");
    }

    const approveRequest = async () => {
        setShowDenyError(false);
        const body = {
            requestId: props.currentUser.requestId,
            applicationId: props.appId,
            adminId: adminCredentials.id,
            reason: reason
        }
        props.submitRequestAction(POST_ENDPOINT.AcceptApplicationAccessRequest, body);
    }

    const denyRequest = async () => {
        setShowDenyError(false);
        if(reason === ''){
            setShowDenyError(true);
            return;
        }
        const body = {
            requestId: props.currentUser.requestId,
            applicationId: props.appId,
            adminId: adminCredentials.id,
            reason: reason
        }
        props.submitRequestAction(POST_ENDPOINT.DenyApplicationAccessRequest, body);
    }

    return (
        <Dialog open={props.actionPopup != ""} onClose={closePopup} fullWidth maxWidth={'md'}>
            <DialogTitle>Permission request</DialogTitle>
                <DialogContent>
                        <DialogContentText> Application: {props.appName} </DialogContentText>
                        <DialogContentText> Firstname: {props.currentUser.firstName} </DialogContentText>
                        <DialogContentText> Lastname: {props.currentUser.lastName} </DialogContentText>
                        <DialogContentText> Email:  <Button className='link-imitation' onClick={() => props.userRedirect({pathname: `/edit-user`, search: `?user=${props.currentUser.id}&country=${props.currentUser.country}`})}>{props.currentUser.email}</Button>  </DialogContentText>
                        {showDenyError && <DialogContentText className='error'>You must enter a valid reason for rejecting the request.</DialogContentText>}
                        <DialogContentText>
                            Please enter reason for decision:
                        </DialogContentText>
                        <TextField type="text" margin="dense" fullWidth variant="standard" onChange={(e) => setReason(e.target.value)} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={approveRequest} className="approve-btn">
                        Approve
                    </Button>
                    <Button onClick={denyRequest} className="deny-btn">
                        Deny
                    </Button>
                </DialogActions>

        </Dialog>
    )
}

export default RequestActionApplication